<template>
  <div
    class="pane content-list"
    ref="box2"
    id="box2"
    :class="listWrap"
    v-if="$isMobile ? mobileList : false"
  >
    <div class="ly-list list-view">
      <div class="ly-list-top">
        <div class="ly-title" v-if="!$isMobile()">
          <h3 class="title-sub">수신그룹 목록</h3>
          <el-button class="btn-toggle" @click="onTableView()">
            <i class="el-icon-arrow-right" v-if="isToggle2 == false"></i>
            <i class="el-icon-arrow-left" v-else></i>
          </el-button>
        </div>
        <div class="ly-filter">
          <idc-search-catalog
            classType="ly-type3"
            :filterData="filterDataMsgGroup"
            :filterFormData="filterFormData"
            :mobileFilter="mobileFilter"
            :page="'MSGGROUP'"
            @filterServiceCatalogKeyword="filterMsgGroupList"
            @search:searchServiceCatalog="searchMsgGroup"
            @clearSearchFilter="clearSearchFilter"
          />
          <div class="ly-sort ly-sort-his ly-sort-list">
            <div class="sort-count">
              <p class="table-cell-all">
                {{ $t("messages.all") }}
                <span class="table-cell-count">{{pageInfo.totalListSize}}</span
                >{{ $t("messages.unit") }}
              </p>
              <div class="sort-select">
                <el-select
                  size="medium"
                  v-model="count"
                  :placeholder="$t('messages.plCount25')"
                >
                  <el-option
                    v-for="item in countList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span>
                  {{ $t("messages.perShow") }}
                </span>
              </div>
            </div>
            <div v-if="!$isMobile()">
              <el-button
                plain
                size="small"
                type="primary"
                @click="regMsngTmpltRcvGroup"
                >{{ $t("messages.btnRegist") }}</el-button
              >
              <el-button plain size="small" type="excel"
                @click="downloadExcel"
                >{{ $t("messages.btnExcel")
                }}<i class="icon-DownloadSimple"></i
              ></el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="ly-list-content">
        <template>
          <idc-list
            :height="990"
            :width="1000"
            :filterText="searchInfo.keyword"
            :tableHeader="tableHeader"
            :tableData="tableData"
            @row-click="rowClick"
            ref="list"
            autoWidth
          >
            <template #col4="{ scope }">
              <el-button type="minus" @click="onMinus(scope.row)"
                ><i class="icon-Minus"
              /></el-button>
            </template>
            <template #col5="{ scope }">
              <el-checkbox v-model="scope.row.col5" />
            </template>
            <infinite-loading
              slot="append"
              ref="infiniteLoad"
              spinner="waveDots"
              @infinite="infiniteScroll"
            >
              <div slot="no-results"></div>
              <div slot="no-more"></div>
            </infinite-loading>
          </idc-list>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { commonExcelDownload, getNow, getDateFormatter } from "@/assets/js/common.js";
import commonMixin from "@/mixins/commonMixin";
import IdcSearchCatalog from "@/components/IdcSearchCatalog.vue";
import IdcList from "@/components/common/IdcList";
import InfiniteLoading from "vue-infinite-loading";

export default {
  mixins: [commonMixin],
  components: {
    IdcSearchCatalog,
    IdcList,
    InfiniteLoading
  },
  created() {
  },
  computed: {
    currentTreeCd() {
      // TODO 검색조건 false
      return this.$store.getters['msgGroupManageStore/getCurrentTreeCd'];
    },
    popupYn() {
      return this.$store.getters['popupManageStore/getModalSelectMsgGroup'];
    }
  },
  watch: {
    currentTreeCd() {
      this.resetInfiniteLoad();
    },
    count(newValue) {
      this.resetInfiniteLoad();
      this.pageInfo.pageListSize = newValue;
    }
  },
  data() {
    return {
      filterFormData: {
        useYnOption: [
          {
            label: "Y",
            value: "Y",
          },
          {
            label: "N",
            value: "N",
          },
        ],
      },
      filterDataMsgGroup: {
        msngRcvCtgNm: "",
        tmpltNm: "",
        regrNm: "",
        date: ""
      },
      mobileFilter: {
        filter1: "",
        filter2: "",
      },
      tableHeader: [
        {
          prop: "rn",
          label: "No",
          width: 70,
        },
        {
          prop: "msngRcvCtgNm",
          label: "그룹 유형",
          width: 100,
        },
        {
          prop: "tmpltNm",
          label: "수신그룹명",
          width: 250,
        },
        {
          prop: "useYn",
          label: "사용여부",
          width: 100,
        },
        {
          prop: "regrNm",
          label: "등록자",
          width: 150,
        },
        {
          prop: "regDt",
          label: "등록일",
          width: 250,
        },
      ],
      tableData: [],
      count: 25,
      countList: [
        {
          label: "25개",
          value: "25",
        },
        {
          label: "50개",
          value: "50",
        },
        {
          label: "100개",
          value: "100",
        },
      ],
      tempType: "sms",
      pageInfo: {
        curPage: 1,
        startIndex: 0,
        lastIndex: 25,
        pageListSize: 25,
        totalListSize: 0,
        delYn: "N",
      },
      searchInfo: {
        keyword: ""
      }
    }
  },
  methods: {
    rowClick(row) {
      this.$store.commit('msgGroupManageStore/setCurrentMsngTmpltRcvGroup', row);
      if (this.popupYn) {
        this.$emit("selectMsgGroup", row);
      }
    },
    infiniteScroll($state) {
      setTimeout(async () => {
        let pageInfo = {
          ...this.pageInfo,
          isPaging: true,
          ...this.filterDataMsgGroup,
          msngRcvCtgCd: this.currentTreeCd.cd || 0
        }

        if (this.filterDataMsgGroup.date) {
          pageInfo.startDate = getDateFormatter(this.filterDataMsgGroup.date[0], "YYYYMMDD") + " 00:00:00";
          pageInfo.endDate = getDateFormatter(this.filterDataMsgGroup.date[1], "YYYYMMDD") + " 23:59:59";
        }

        try {
          const { data } = await this.$BIZ_SERVICE
            .post(this.$API_URLS.Opr.getMsngTmpltRcvGroupList, pageInfo);
          let { list, page } = JSON.parse(data.resData);
          if (list.length > 0) {
            this.pageInfo.curPage += 1;
            this.tableData = this.tableData.concat(list);
            $state.loaded();
          } else {
            $state.complete();
          }
          this.pageInfo.totalListSize = page.totalListSize;
        } catch (err) {
          console.log(err);
        }
      }, 500);
    },
    resetInfiniteLoad() {
      this.tableData = [];
      this.pageInfo.curPage = 1;
      this.$refs.infiniteLoad.stateChanger.reset();
    },
    regMsngTmpltRcvGroup() {
      // TODO TmpltRcvGroup 등록
      const data = {
        useYn: "Y",
        tmpltNm: "",
        tmpltTypeCd: "",
        msngRcvCtgCd: 3291,
        msngRcvCtgNm: "메세지 수신 분류"
      }
      if (this.currentTreeCd.cd > 0) {
        data.msngRcvCtgCd = this.currentTreeCd.cd;
        data.msngRcvCtgNm = this.currentTreeCd.cdHnglNm;
      }
      this.$store.commit('msgGroupManageStore/setCurrentMsngTmpltRcvGroup', data);
    },
    searchMsgGroup() {
      this.resetInfiniteLoad();
    },
    filterMsgGroupList(keyword) {
      this.searchInfo.keyword = keyword;
    },
    initSelectList() {
      // init idc list current cell
      this.$store.commit('msgGroupManageStore/setCurrentMsngTmpltRcvGroup', {});
      this.$refs.list.setCurrent({});
    },

    downloadExcel() {
      let searchData = {
        ...this.filterDataMsgGroup
      };
      if (this.filterDataMsgGroup.date) {
        searchData.startDate = getDateFormatter(this.filterDataMsgGroup.date[0], "YYYYMMDD") + " 00:00:00";
        searchData.endDate = getDateFormatter(this.filterDataMsgGroup.date[1], "YYYYMMDD") + " 23:59:59";
      }
      commonExcelDownload(
        this.$BIZ_SERVICE,
        this.$API_URLS.Com.excelDownloadByService,
        "수신그룹 목록_" + getNow() + ".xlsx",
        "getMsngTmpltRcvGroupList",
        this.tableHeader,
        searchData
      );
    },
    clearSearchFilter() {
      this.filterDataMsgGroup = {
        msngRcvCtgNm: "",
        tmpltNm: "",
        regrNm: "",
        date: ""
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>